














    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    import item from './cultureSelectorItem.vue';
    import iln8 from 'Vue-I18n';
    import { ISupportedCulture } from '../../../../../../CommonScripts/Abstractions';

    export default Vue.extend({
        name: 'culture-selector',
        components: {
            'culture-selector-item': item
        },
        computed: {
            langImageUrl(): string { return `${this.$store.state.baseUrl}images/locale/${this.$store.state.currentCulture}`; },
            btnAriaLabelLanguage(): string { return this.$vuetify.lang.t('webmap.ariaLabels.language'); },
            btnTooltipLanguage(): string { return this.$vuetify.lang.t('webmap.tooltips.language'); }
        },
        methods: {
            selectLanguage(eventArgs): void {
                var name = eventArgs.culture.name;
                if (!this.$store.state.loadedLanguages[name]) {
                    this.$store.commit('ui/setActivityMessage', this.$vuetify.lang.t('webmap.messages.loading'));
                    this.$store.dispatch('loadLanguage', { culture: name })
                        .then((response) => {
                            this.$root.$i18n.setLocaleMessage(name, response);
                            this.$store.commit('setCurrentCulture', name);
                            this.$root.$i18n.locale = name;
                            document.documentElement.lang = name;
                            this.$store.commit('ui/setActivityMessage', '');
                        })
                        .catch(() => {
                            this.$store.commit('ui/setActivityMessage', '');
                            this.$store.commit('ui/setErrorMessage', this.$vuetify.lang.t('webmap.messages.geognosis.error'));
                        });
                }
                else {
                    this.$store.commit('setCurrentCulture', name);
                    this.$root.$i18n.locale = name;
                    document.documentElement.lang = name;

                }
            }
        }
    });
